const domain_info = {
	/* --------------------------- DOMAIN INFO SECTION -------------------------- */
	cancel_button: "Domein opzeggen",

	/* ------------------------------ CANCEL DIALOG ----------------------------- */
	cancel_dialog: {
		description:
			"Ter bevestiging vragen wij u om de domeinnaam <strong>{{domain_name}}</strong> in onderstaand invoerveld in te voeren.",
		info: "Na opzegging blijft uw domein actief tot <strong>{{renewal_date}}</strong>. Na deze datum komt de domeinnaam te vervallen. Let op! De opzegging van een domein is definitief.",
		success_message: "Uw domeinnaam is succesvol opgezegd.",
		title: "Domeinnaam opzeggen",
		validation_input: {
			label: "Domeinnaam invoeren",
			placeholder: "Voer domeinnaam in",
		},
	},
	/* ----------------------------- MANAGE SECTION ----------------------------- */
	manage: {
		add_button: "Domein registreren",
		table: {
			details: "Details",
			dns: { button: "Naar DNS", title: "DNS" },
			domain_name: "Domeinnaam",
			holder: "Houder",
			price: "Prijs",
			registration_date: "Registratie datum",
			renewal_date: "Verlengdatum",
			status: {
				active: "Actief",
				cancellation_pending: "Opzegging in behandeling",
				cancelled: "Opgezegd",
				error: "Niet gelukt",
				in_progress: "In behandeling",
				obsolete: "Verouderd",
				title: "Abonnement",
			},
		},
		title: "Beheren",
	},
	tiles: {
		autorenew_tile: {
			bttn: "Automatisch verlengen inschakelen",
			description: "Status automatisch verlengen",
			dialog: {
				description:
					"Weet je zeker dat je automatisch verlengen wil activeren voor <strong>{{domain_name}}</strong>?",

				messages: {
					success: "Automatisch verlengen ingeschakeld voor <strong>{{domain_name}}</strong>",
				},
				title: "Domeinnaam automatisch verlengen",
			},
			state: ["Uitgeschakeld", "Actief"],
			title: "Automatisch verlengen",
		},
		contact_tiles: {
			admin: "Administratief contact",
			billing: "Facturatie contact",
			not_available:
				"Dit Domein Maakt geen gebruik van Dit type contact profiel of er is iets mis gegaan bij het ophalen van dit profiel.",
			oxxa_value: "Oxxa waarde",
			portal_value: "Portaal waarde",
			tech: "Technisch contact",
		},
		debtor_tile: {
			business: "Zakelijk",
			company_name: "Bedrijfsnaam",
			debtor_code: "Debiteurnummer",
			name: "Naam",
			private: "Particulier",
			title: "Debiteur",
		},
		holder_tile: {
			address: "Adres",
			change_holder: "Andere houder selecteren",
			coc_number: "KvK nummer",
			company_name: "Bedrijfsnaam",
			email_address: "E-mailadres",
			first_name: "Voornaam",
			last_name: "Achternaam",
			middle_name: "Tussenvoegsel",
			phone_number: "Telefoonnummer",
			salutation: "Aanhef",
			title: "Houder",
			vat_number: "BTW nummer",
		},
		info_tile: {
			authorization_code: {
				button: "Token opvragen",
				no_token: "Check uw email voor de Autorisatiecode",
				title: "Autorisatiecode (token)",
			},
			auto_renew_date: "Verlengdatum",
			dns_sec: { button: "DNSsec openen", title: "DNSsec" },
			expire_date: "Vervaldatum",
			local_presence: {
				tip: "Gevolmachtigde tooltip",
				title: "Gevolmachtigde",
				true: "In gebruik",
			},
			price: { tip: "De prijs bij verlenging kan enigszins afwijken.", title: "Actuele prijs" },
			registration_date: "Registratie datum",
			title: "Domein informatie",
		},
		nameserver_tile: {
			change_ns_group: "NS-groep wijzigen",
			nameserver: "Nameserver",
			title: "Nameservers",
			used_nameservers_for_domain:
				"De onderstaande nameservers zullen gebruikt worden voor de domein(en):",
		},
		oxxa_error_tile: {
			description:
				"(Superuser-Only) \n Het lijkt er op dat er geen verbinding kan gemaakt kan worden met Oxxa op dit moment, dit is nodig om bepaalde domain-houder informatie in te zien. Probeer het later nog eens of neem contact op met een developer.",
			domain_info_not_available:
				"Let op! De onderstaande informatie Kon niet worden bijgewerkt, De onderstaande informatie is mogelijk niet actueel.",
			mismatch_on_identities:
				"Let op! De onderstaand houder informatie komt mogelijk niet overeen, neem contact op met Tuxis support.",
		},
	},

	/* ----------------------------- TRANSFER DIALOG ---------------------------- */
	transfer_dialog: {
		cancel_checkbox: {
			label: "Dit domein opzeggen per <strong>{{date}}</strong>",
			tooltip:
				"Een domeinnaam dient 30 dagen voorafgaand de verlengdatum opgezegd te worden. Anders wordt deze voor het komende jaar gefactureerd",
		},
		description:
			"Mocht de code na het opvragen niet zichtbaar zijn op de huidige pagina, dan wordt deze gemaild naar het volgende mailadres:\n<strong>{{email_address}}</strong>",
		error_messages: {
			cancel_domain:
				"Let op! De domeinnaam MOET voor {{date}} verhuisd zijn anders wordt deze per {{expire_date}} <strong>vrijgegeven</strong> en kan door derden geregistreerd worden!",
			renewal_date:
				"De domeinnaam moet voor <strong>{{date}}</strong> verhuisd zijn, anders wordt dit domein verlengd en gefactureerd.",
			unknown:
				"Er is iets misgegaan tijdens het aanvragen van de verhuiscode, probeer het nogmaals of neem contact op met onze support afdeling.",
		},
		success_message:
			"De verhuiscode is succesvol verzonden naar het e-mailadres van de domeinhouder.",
		title: "Verhuiscode opvragen",
	},
};

export default domain_info;
